import {apiRetrieveImproved} from "@/api.ts";
import Content from "@/components/Content.tsx";
import Header from "@/Header.tsx";
import {useJwtUser} from "@/JWTAuthProvider.tsx";
import {Subscription} from "@/types";
import queryKeys from "@/utilities/queryKeys.ts";
import {Card, CardBody, CardHeader} from "@heroui/react";
import {Table, TableBody, TableCell, TableColumn, TableHeader, TableRow} from "@heroui/table";
import {useQuery} from "@tanstack/react-query";
import {createFileRoute} from '@tanstack/react-router'
import React from "react";

export const Route = createFileRoute('/_app/billing')({
    component: RouteComponent,
    loader:    async () => {
    },
})

function RouteComponent() {
    const user = useJwtUser();

    const subscriptionsQuery = useQuery({
        queryKey: queryKeys.profile_subscriptions(),
        queryFn:  async () => apiRetrieveImproved('subscriptions' as any),
        enabled:  !!user?.uid,
    })
    const transactionsQuery = useQuery({
        queryKey: queryKeys.transactions(),
        queryFn:  async () => apiRetrieveImproved('transactions' as any),
        enabled:  !!user?.uid,
    })

    if (!subscriptionsQuery.isFetched || !transactionsQuery.isFetched || !user) {
        return null;
    }

    return <>
        <Header />

        <Content>
            {/* Most visitors arrive via the "Transactions" menu entry and hold no personal
                subscription, so a blanket "Subscription" heading over a transactions list misleads. */}
            <h2 className={"text-lg font-semibold mb-4"}>
                {(subscriptionsQuery.data?.subscriptions || []).length > 0 ? 'Subscription' : 'Transactions'}
            </h2>
            {(subscriptionsQuery.data?.subscriptions || []).map((sub: Subscription) => (<>

                    <Card className={"mb-4"}>
                        <CardHeader className={"font-semibold"}>
                            Active Subscription
                        </CardHeader>
                        <CardBody>
                            Purchase on: <strong>{sub.subscription_source === 'appstore' ? 'Apple App Store' : 'scorepal.co'}</strong><br />
                            Next payment due on: <strong>{sub.expires_at?.substring(0, 10)}</strong><br />
                        </CardBody>
                    </Card>
                </>
            ))}

            <Card>
                <CardHeader>
                    Transactions
                </CardHeader>
                <CardBody>
                    <Table aria-label="Transactions list" classNames={{wrapper: "p-1", th: "px-1 text-center", td: "px-1 py-1 text-center"}}
                           isVirtualized={true}
                           isStriped={true}
                           isHeaderSticky={true}>
                        <TableHeader>
                            <TableColumn className={"text-left"}>Date</TableColumn>
                            <TableColumn className={"text-left"}>Amount</TableColumn>
                            <TableColumn className={"text-left"}>Status</TableColumn>
                        </TableHeader>
                        <TableBody>
                            {transactionsQuery.data?.transactions.map((transaction: any) => (
                                <TableRow key={transaction.uid}>
                                    <TableCell className={"text-left"}>
                                        ID: {transaction.uid}<br />
                                        {transaction.created_at.replace('T', ' ').replace(/\..*/, '')}<br />
                                    </TableCell>
                                    <TableCell className="text-left pl-2">
                                        {transaction.product?.name}<br />
                                        {transaction.amount_cents / 100} {transaction.currency_code}
                                    </TableCell>
                                    <TableCell className="text-left pl-2">
                                        {transaction.status}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>

                    {transactionsQuery.data?.transactions?.length === 0 && "No transactions found."}

                </CardBody>
            </Card>
        </Content>
    </>
}
